import { render, staticRenderFns } from "./ModalProtocolFilter.vue?vue&type=template&id=36a32116&scoped=true"
import script from "./ModalProtocolFilter.vue?vue&type=script&lang=js"
export * from "./ModalProtocolFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a32116",
  null
  
)

export default component.exports